import React, { useEffect, useState } from 'react';
import '../../campaign/campaignCreation/CreateCampaignStepTwo.scss';
import { connect } from 'react-redux';
import { ActionType, APIStatus, CampaignType } from '../../../config/CustomEnums';
import {
  ContinueWithBackAndTempSaveButtons,
} from '../../base/BottomStepComponent';
import {
  defaultPreviewImage,
  getPreviewLayoutImages,
} from '../../campaign/campaignCreation/CampaignStepTwoPreviewConfig';
import { useFormContext } from 'react-hook-form';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';
import { CREATION_STEP_ONE_CONFIG } from './StampCampaignCreationConfig';
import { useParams } from 'react-router-dom';
import { scrollToAnchor } from 'components/campaignStreamline/CreateCampaignHandleError';
import PublishCampaignPrompt from 'components/campaign/campaignCreation/PublishCampaignPrompt';

function CreateStampCampaignStepOneV2({
  anchorKey,
  sectionKey,
  createStatus,
  formHasSubmitted,
  languages,
  onStepChange,
  onSaveTemp,
 }) {
  const formContext = useFormContext()
  const { getValues, formState: { errors }, setValue } = formContext;
  const errorLanguage = Object.keys(errors?.translations || [])?.[0];
  const params = useParams();
  const campaignId = params.id;
  const isEditMode = !!campaignId;
  const campaignTypeField = "campaignType"
  const defaultCampaignType = CampaignType.stampCampaign;
  const defaultImage = defaultPreviewImage(defaultCampaignType);
  const inputWithImageConfig = getPreviewLayoutImages(defaultCampaignType);
  const [fieldsError, setFieldsError] = useState(Object.keys(errors || []).length);
  const [showPublishPrompt, setShowPublishPrompt] = useState(false);

  useEffect(() => {
    if (getValues(campaignTypeField) === defaultCampaignType) {
      return;
    }
    setValue(campaignTypeField, defaultCampaignType);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languages, defaultCampaignType]);

  useEffect(() => {
    scrollToAnchor(anchorKey, sectionKey);
  }, [anchorKey, sectionKey]);

  useEffect(() => {
    setFieldsError(Object.keys(errors || []).length);
  }, [errors]);
      useEffect(() => {
        if (createStatus === APIStatus.success && formHasSubmitted) {
          setShowPublishPrompt(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [createStatus, formHasSubmitted]);
  
  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_ONE_CONFIG}
        fieldsError={fieldsError}
        errorLanguage={errorLanguage}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultImage}
      />
      <ContinueWithBackAndTempSaveButtons
        {...isEditMode ? {} : {
          saveTempText: "Save as draft",
          saveTempAction: () => {
            onSaveTemp && onSaveTemp(formContext)
          }
        }}
        continueAction={() => {
          setFieldsError(0);
          onStepChange(1);
        }}
      />
      <PublishCampaignPrompt
        campaignId={campaignId}
        campaignType={CampaignType.stampCampaign}
        actionType={ActionType.save}
        show={showPublishPrompt}
        path={'/stamp_campaigns'}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  anchorKey: state.campaignStreamline.anchorKey,
  sectionKey: state.campaignStreamline.sectionKey,
  createStatus: state.createCampaign.createStatus,
  formHasSubmitted: state.createCampaign.formHasSubmitted,
  languages: state.language.allList,
});

export default connect(mapPropsToState)(CreateStampCampaignStepOneV2);
